import { Url } from 'next/dist/shared/lib/router/router'
import Image from 'next/image'

import { CopyrightText } from '@/components/copyright-text'
import { BackButton } from '@/components/ui/back-button'

import IconBack from '@/assets/icons/ic_logic-g-app_arrow-quite.svg'

interface BlueLayoutProps {
  backUrl?: Url
  children: React.ReactNode
}

export const BlueLayout = (props: BlueLayoutProps): JSX.Element => {
  return (
    <main className="flex min-h-screen flex-col bg-[#5166C7]">
      <div className="grid w-full grid-cols-[1fr_auto_1fr] bg-white p-[10px] py-2">
        {props.backUrl && typeof props.backUrl === 'string' ? (
          <div className="item-center flex">
            <BackButton
              backUrl={props.backUrl}
              icon={IconBack}
              ariaLabel="Back"
            />
          </div>
        ) : (
          <div></div>
        )}
        <Image src="/gApp_logo.svg" width={130} height={35} alt="LogiQlabo" />
      </div>
      <div className="flex grow flex-col">{props.children}</div>
      <footer className="mt-auto py-3">
        <p className="text-center text-xs text-[#FFFFFF]">
          <CopyrightText />
        </p>
      </footer>
    </main>
  )
}

export function getBlueLayout(page: React.ReactElement): JSX.Element {
  return <BlueLayout>{page}</BlueLayout>
}
